// extracted by mini-css-extract-plugin
export default {"calendar-styles":"Calendar_calendar-styles__zhEl4"};